import React from "react";

const ErrorFallback = () => {
  const handleGoHome = () => {
    window.location.replace("/digital-onboarding");
  };

  const styles = {
    container: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      minHeight: "100vh",
      backgroundColor: "#ffffff",
      padding: "20px",
      fontFamily: "'Roboto-Medium', Roboto, sans-serif",
    },
    content: {
      textAlign: "center",
      maxWidth: "600px",
      width: "100%",
      padding: "48px 32px",
    },
    iconContainer: {
      marginBottom: "32px",
    },
    icon: {
      width: "80px",
      height: "80px",
      margin: "0 auto",
    },
    subtitle: {
      color: "#d3d3d3",
      fontSize: "13px",
      letterSpacing: "5px",
      textTransform: "uppercase",
      marginBottom: "8px",
      fontWeight: "500",
    },
    heading: {
      fontSize: "1.2rem",
      fontWeight: "600",
      color: "#053A8A",
      marginBottom: "24px",
      lineHeight: "1.3",
    },
    message: {
      fontSize: "16px",
      color: "#212529bf",
      lineHeight: "1.6",
      marginBottom: "32px",
      fontFamily: "'Roboto-Regular', Roboto, sans-serif",
    },
    button: {
      backgroundColor: "#1a73e8",
      color: "#ffffff",
      border: "none",
      borderRadius: "8px",
      padding: "12px 24px",
      fontSize: "16px",
      fontWeight: "600",
      cursor: "pointer",
      width: "100%",
      maxWidth: "600px",
      transition: "background-color 0.2s ease",
      fontFamily: "'Roboto-Medium', Roboto, sans-serif",
    },
  };

  return (
    <div style={styles.container}>
      <div style={styles.content}>
        {/* Icon */}
        <div style={styles.iconContainer}>
          <div style={styles.icon}>
            <img
              src="/assets/scan_error.svg"
              className="scan-result-icon"
              alt="error"
            />
          </div>
        </div>

        {/* Subtitle */}
        <div style={styles.subtitle}>ERROR</div>

        {/* Heading */}
        <h1 style={styles.heading}>Something went wrong</h1>

        {/* Message */}
        <p style={styles.message}>
          We encountered an unexpected error. Please return to home to continue.
        </p>

        {/* Button */}
        <button
          style={styles.button}
          onClick={handleGoHome}
          onMouseEnter={(e) => {
            e.target.style.backgroundColor = "#1557b0";
          }}
          onMouseLeave={(e) => {
            e.target.style.backgroundColor = "#1a73e8";
          }}
        >
          Go to Home
        </button>
      </div>
    </div>
  );
};

export default ErrorFallback;
